module.exports = __webpack_public_path__ + "media/images/client-wessex-water-7b11f7f8c887890665115ee6e334eb93.png";